import React, { useState, useEffect } from "react";
import { API_URL } from "../helpers";

import Alert from "../components/Alert";
import Input from "../components/Input";
import Checkbox from "../components/Checkbox";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Report2 = ({ token }) => {
  const [errors, setErrors] = useState([]);
  const [names, setNames] = useState({
    token,
  });
  const [msg, setMsg] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  useEffect(() => {
    init();

    // eslint-disable-next-line
  }, []);

  const init = async () => {
    const url = new URL(`${API_URL}/auth/charityReport2Init`);
    const params = {
      token: names.token,
    };
    url.search = new URLSearchParams(params);

    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-store",
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        handleUpdate("email", json.email);
        setAlert({});
      } else {
        setAlert({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setAlert({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  const handleUpdate = (name, value) => {
    setNames((names) => ({ ...names, [name]: value ? value : "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/auth/charityReport2`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      if (key === "all") {
        data.append(key, value ? "1" : "0");
      } else {
        data.append(key, value);
      }
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setMsg({
          type: "success",
          text: json.text,
        });
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <>
      {alert.type ? (
        <Alert data={alert} />
      ) : (
        <form
          method="post"
          action="/"
          onSubmit={(e) => handleSubmit(e)}
          className="well"
        >
          <p style={{ marginTop: "0" }}>
            Use this form to email an .csv export of people who have signed up
            as Friendraiser for your charity.
          </p>

          <div className={names.all ? "hidden" : ""}>
            <div className="form-group">
              <Input
                name="email"
                label="Email"
                reqd={true}
                value={names.email || ""}
                update={handleUpdate}
                errors={errors}
              />
              <div />
            </div>
          </div>

          <div className="form-group checkbox" style={{ marginTop: "10px" }}>
            <Checkbox
              name="all"
              label="Check to email report to all charity contacts."
              checked={names.all || false}
              click={handleUpdate}
            />
          </div>

          <div className="msg-submit">
            {msg.type && <Msg data={msg} />}

            <div
              className={msg.type === "working" ? "hidden" : "submit-container"}
            >
              <Submit path="" left="" submit="Generate & Email Report" />
            </div>
          </div>
        </form>
      )}
    </>
  );
};

export default Report2;
